export default __webpack_public_path__ + "static/media/mp_edit.c96714c1.svg";